import { combineReducers } from 'redux';
import { user } from './users';
import { campaign } from './campaign';
import { account } from './account';
import { monitoramento } from './monitoramento';


const rootReducer = combineReducers({
	user: user,
	campaign: campaign,
	account: account,
	monitoramento: monitoramento
});
export default rootReducer;
